//---React Libraries
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
//---ANT Design
import { Col, Row } from "antd";
//---Project Imports
import { setSelectedHBTestId } from "reducers/eolTestsSlice";
import HeartBeatLayout from "./Panels/HeartBeatLayout";
import HBComment from "./Panels/HBComment";

const Connectivity = ({ isModalOpen, onChangeImei, vehicle }) => {
  const dispatch = useDispatch();
  const eol = useSelector((state) => state.eolTests);
  const vehicleSlice = useSelector((state) => state.eol);
  const vehicleDetails = vehicleSlice?.vehicleDetails;
  const selectedTab = eol?.selectedTab;
  const HBStartDetails = eol?.HBStartDetails;
  const HBTestRunningStatus = eol?.HBTestRunningStatus;
  const [commentModalOpen, setCommentModalOpen] = useState(false);

  const showCommentModal = () => {
    setCommentModalOpen(true);
  };
  const handleCloseModal = () => {
    setCommentModalOpen(false);
  };

  useEffect(() => {
    if (
      vehicleDetails?.previousTests?.connectivity &&
      selectedTab === "heartBeat"
    ) {
      const testId = HBTestRunningStatus
        ? HBStartDetails?.testId
        : vehicleDetails?.previousTests?.connectivity;
      dispatch(setSelectedHBTestId(testId));
    }
    // eslint-disable-next-line
  }, [selectedTab, vehicleDetails]);

  return (
    <Row gutter={16}>
      {commentModalOpen ? (
        <HBComment
          isModalOpen={commentModalOpen}
          handleCloseModal={handleCloseModal}
          formName={selectedTab}
        />
      ) : null}
      <Col span={24}>
        <HeartBeatLayout
          onChangeImei={onChangeImei}
          vehicle={vehicle}
          showCommentModal={showCommentModal}
        />
      </Col>
    </Row>
  );
};

export default Connectivity;
